import { Reveal } from "./Reveal";

export const Guarantee = () => (
  <section data-testid="guarantee-section" className="py-20 md:py-28 bg-[#0f0f13] border-y border-[#d4af37]/10">
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-12 gap-12 items-center">
      <Reveal className="md:col-span-4 flex justify-center md:justify-start">
        <div className="relative">
          <div className="absolute -inset-8 bg-[#d4af37]/10 blur-3xl rounded-full" />
          <div className="relative w-48 h-48 rounded-full border-2 border-[#d4af37]/50 bg-[#1f1a08]/60 flex flex-col items-center justify-center gold-glow">
            <span className="font-serif text-6xl font-bold text-gold-gradient">7</span>
            <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#f5d77f] mt-1">dias de</span>
            <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#f5d77f]">garantia</span>
            <div className="absolute inset-2.5 rounded-full border border-dashed border-[#d4af37]/30" />
          </div>
        </div>
      </Reveal>
      <div className="md:col-span-8">
        <Reveal delay={0.1}>
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#d4af37]">Risco zero</p>
          <h2 className="mt-4 font-serif text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#f4f1ea]">
            Garantia incondicional de <span className="text-gold-gradient italic">7 dias</span>
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-6 text-base sm:text-lg text-zinc-400 leading-relaxed">
            Leia o livro inteiro. Aplique os exercícios. Se em até 7 dias você sentir que não era
            para você — por qualquer motivo, ou por motivo nenhum — basta um e-mail e devolvemos
            <span className="text-[#f4f1ea] font-semibold"> 100% do seu investimento</span>.
            Sem perguntas, sem burocracia, sem ressentimentos.
          </p>
          <p className="mt-4 font-serif italic text-lg text-zinc-300">
            O estoico não teme o risco — porque o elimina antes de agir.
          </p>
        </Reveal>
      </div>
    </div>
  </section>
);
